import React from 'react'
import { Icon } from '~/types'
import { icons } from '~/utils'

export const Download: React.FunctionComponent<Icon.Props> = ({ mode = 'light' }) => {
  const color = icons.getIconColor(mode)

  return (
    <svg width="12px" height="12px" fill="none" viewBox="0 0 24 24" stroke={color} className="download">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
      ></path>
    </svg>
  )
}

export default Download
